import request from '@/utils/request'

// 新增业务在线申请管理
export function addYwzxsq(data) {
  return request({
    url: '/web/jyjcfw/ywzxsq',
    method: 'post',
    data: data
  })
}

// 修改业务在线申请管理
export function updateYwzxsq(data) {
  return request({
    url: '/web/jyjcfw/ywzxsq/edit',

    method: 'post',
    data: data
  })
}

// 查询业务在线申请管理详细
export function getYwzxsq(recid) {
  return request({
    url: '/web/jyjcfw/ywzxsq/' + recid,
    method: 'get'
  })
}

// 下载pdf
export function downloadPdfCpzljc() {
  return request({
    url: '/web/jyjcfw/ywzxsq/downloadPdfCpzljc',
    method: 'get',
    //headers: { 'Content-Type': 'application/pdf; charset=UTF-8' }, 
    responseType: 'blob', // 必须写这行
  })
}